module.exports = __webpack_public_path__ + "img/case_slide_1.8b6236e1.png";